import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import Icon              from "_components/atoms/icon";
import ToolTip           from "_components/atoms/tooltip";
import Typography        from "_components/atoms/typography";
import Settings          from "_components/organisms/notificationTab/components/notificationSettings/notificationToggleSettings";
import useStyles         from "./styles";

const component = props => {

	const
		{
			handleSettingsClose,
			notificationSettings,
			updateNotificationStates,
			saveNotificationSettings
		}
	= props;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<>
			<BackgroundWrapper className = { classes.header }
				type = "tertiary"
			>
				<div className = { classes.titleContainer }>
					<div className = { classes.backAndTitleContainer }>
						<Icon
							className = { classes.backIcon }
							name      = "backArrow"
							onClick   = { handleSettingsClose }
						/>

						<Typography
							className = { `${ classes.title } fontBold` }
							color     = "primary"
							title     = { "Notification Settings" }
							variant   = "body1"
						/>
					</div>

					<ToolTip
						arrow
						placement = "bottom-end"
						title     = "Save Settings"
					>
						<div>
							<Icon
								className = { classes.tickIcon }
								name      = "notifSaveTick"
								onClick   = { saveNotificationSettings }
							/>

						</div>
					</ToolTip>

				</div>
			</BackgroundWrapper>

			<div className = { classes.settingsFeedContent }>

				<Typography
					className = { `${ classes.settingstitle } fontBold` }
					color     = "primary"
					title     = { "Personalised" }
					variant   = "body1"
				/>

				<Settings
					enabledState = { notificationSettings?.["subscribed"]?.enabledState }
					settingsName = "subscribed"
					title        = "Subscribed"
					updateNotificationStates = { updateNotificationStates }
				/>

				<Settings
					enabledState = { notificationSettings?.["recommendations"]?.enabledState }
					settingsName = "recommendations"
					title        = "Recommendations for you"
					updateNotificationStates = { updateNotificationStates }
				/>

				<Typography
					className = { `${ classes.settingstitle } fontBold` }
					color     = "primary"
					title     = { "Interactions" }
					variant   = "body1"
				/>

				<Settings
					enabledState = { notificationSettings?.["new_followers"]?.enabledState }
					settingsName = "new_followers"
					title        = "New Followers"
					updateNotificationStates = { updateNotificationStates }
				/>

				<Settings
					enabledState = { notificationSettings?.["comments_on_your_post"]?.enabledState }
					settingsName = "comments_on_your_post"
					title        = "Comments on your post."
					updateNotificationStates = { updateNotificationStates }
				/>

				<Settings
					enabledState = { notificationSettings?.["likes_on_your_post"]?.enabledState }
					settingsName = "likes_on_your_post"
					title        = "Likes on your post."
					updateNotificationStates = { updateNotificationStates }
				/>

				<Settings
					enabledState = { notificationSettings?.["shares_on_your_post"]?.enabledState }
					settingsName = "shares_on_your_post"
					title        = "Shares on your post."
					updateNotificationStates = { updateNotificationStates }
				/>

				<Settings
					enabledState = { notificationSettings?.["stream_summary"]?.enabledState }
					settingsName = "stream_summary"
					title        = "Stream Summary"
					updateNotificationStates = { updateNotificationStates }
				/>

				<Typography
					className = { `${ classes.settingstitle } fontBold` }
					color     = "primary"
					title     = { "Updates" }
					variant   = "body1"
				/>

				<Settings
					enabledState = { notificationSettings?.["daily_growth_reports"]?.enabledState }
					settingsName = "daily_growth_reports"
					title        = "Weekly Growth Reports"
					updateNotificationStates = { updateNotificationStates }
				/>

				<Settings
				// backend saves it as daily_growth_reports, kept it same
					enabledState = { notificationSettings?.["achievements"]?.enabledState }
					settingsName = "achievements"
					title        = "Achievements"
					updateNotificationStates = { updateNotificationStates }
				/>

				<Settings
					enabledState = { notificationSettings?.["alerts"]?.enabledState }
					settingsName = "alerts"
					title        = "Alerts"
					updateNotificationStates = { updateNotificationStates }
				/>

				<Typography
					className = { `${ classes.settingstitle } fontBold` }
					color     = "primary"
					title     = { "Wallet" }
					variant   = "body1"
				/>

				<Settings
					enabledState = { notificationSettings?.["coins_added"]?.enabledState }
					settingsName = "coins_added"
					title        = "Coins Added"
					updateNotificationStates = { updateNotificationStates }
				/>

				<Settings
					enabledState = { notificationSettings?.["diamonds_added"]?.enabledState }
					settingsName = "diamonds_added"
					title        = "Diamonds Added"
					updateNotificationStates = { updateNotificationStates }
				/>

			</div>

		</>
	);
};

export default component;
